// extracted by mini-css-extract-plugin
var _1 = "ControlBarBacklinks-module__animatedBackground--M06GN";
var _2 = "ControlBarBacklinks-module__container--YzarE";
var _3 = "ControlBarBacklinks-module__icon--nIuw2";
var _4 = "ControlBarBacklinks-module__inactiveBacklinksContainer--tkjm8";
var _5 = "ControlBarBacklinks-module__label--U3wPU";
var _6 = "ControlBarBacklinks-module__row--lPM9U";
var _7 = "ControlBarBacklinks-module__showInactiveBacklinksButton--srSgs";
var _8 = "ControlBarBacklinks-module__showInactiveBacklinksButtonContainer--HpylR";
var _9 = "ControlBarBacklinks-module__title--l8Pzb";
export { _1 as "animatedBackground", _2 as "container", _3 as "icon", _4 as "inactiveBacklinksContainer", _5 as "label", _6 as "row", _7 as "showInactiveBacklinksButton", _8 as "showInactiveBacklinksButtonContainer", _9 as "title" }
